import { render } from "./vdentlogo.vue?vue&type=template&id=66c9556e"
import script from "./vdentlogo.vue?vue&type=script&lang=js"
export * from "./vdentlogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__